import { render, staticRenderFns } from "./Questions.vue?vue&type=template&id=aa410a2e&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=js"
export * from "./Questions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa410a2e",
  null
  
)

export default component.exports